export class Declaracion{
	constructor(
		public id: number, 
		public grupo_id: number,
		public empresa_id: number,
		public tipo_declaracion_id: number,
		public anio_id: number,
		public mes_id: number,
		public monto: string,
		public ocupacion: number,
		public detalles: string
	){}
}